'use client'

import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from './GlobalStyles'
import Providers from './Providers'
import axios from 'axios'
import { configureAxiosForClient } from '../utils/configureAxiosForClient'
import UnavailableStore from '../themes/common/StoreNotFound/UnavailableStore'
import { breakpoints } from '../lib/Media'
import { FaroErrorBoundary } from '@grafana/faro-react'
import ErrorBoundary from '../lib/ErrorBoundary'
import GATracker from '../lib/tracking'
import GTMWrapper from '../lib/GtmWrapper'
import { useSelector } from 'react-redux'
// import { Provider } from 'react-redux'
// import store from '../reduxToolkit/store'
// import ReduxStoreInitializers from './ReduxStoreInitializers'
import { serviceable } from '../reduxToolkit/addressSlice'
import { Header, Sidebar, Footer, FixedCartBottom } from '../themes'

export default function ClientLayout({ children, theme, ...props }) {
  const accountContext = useSelector((state) => state.account)
  const { address: addressSelector } = useSelector((state) => state.address)
  const {
    websiteTheme,
    organizationData,
    loading,
    currentPath,
    googleAnalyticsAccountKey,
    dynamicStyles,
    dir,
    domain,
    accountData,
    navigationData,
    footerData,
    homeData,
    announcementData,
    address,
    storeId,
    dictionaryList,
    currentTheme,
    underMaintenace,
    fbAnalyticsId,
    conversionArray,
    scriptBody,
    selectedLanguage,
    isStoreAvailable,
    orgStatusCode,
  } = props

  useEffect(() => {
    const { isLoggedin, userData } = accountContext || {}
    if (isLoggedin && !addressSelector.address) {
      const defaultCheckoutAddress = userData.defaultAddress
      serviceable(defaultCheckoutAddress)
    }
  }, [accountContext])

  const themesWithSideMenu = ['Zopnow', 'theme-wsi']

  const hasSideMenu = themesWithSideMenu.includes(websiteTheme)

  return (
    // <Provider store={store}>
    <ThemeProvider theme={{ ...dynamicStyles, breakpoints, dir }}>
      {isStoreAvailable ? (
        <>
          <GlobalStyles
            theme={websiteTheme}
            themeName={organizationData?.theme?.name}
            direction={selectedLanguage?.id === 'ar' ? 'rtl' : 'ltr'}
          />
          <FaroErrorBoundary>
            <ErrorBoundary>
              {/* <ReduxStoreInitializers {...props} /> */}

              {googleAnalyticsAccountKey && (
                <GATracker
                  googleAnalyticsAccountKey={googleAnalyticsAccountKey}
                  path={currentPath}
                />
              )}
              <GTMWrapper organizationData={organizationData}>
                <Providers
                  websiteTheme={websiteTheme}
                  organizationData={organizationData}
                  loading={loading}
                  currentPath={currentPath}
                  googleAnalyticsAccountKey={googleAnalyticsAccountKey}
                  dynamicStyles={dynamicStyles}
                  dir={dir}
                  domain={domain}
                  accountData={accountData}
                  navigationData={navigationData}
                  footerData={footerData}
                  homeData={homeData}
                  announcementData={announcementData}
                  address={address}
                  storeId={storeId}
                  dictionaryList={dictionaryList}
                  currentTheme={currentTheme}
                  underMaintenace={underMaintenace}
                  fbAnalyticsId={fbAnalyticsId}
                  conversionArray={conversionArray}
                  scriptBody={scriptBody}
                  selectedLanguage={selectedLanguage}
                  isStoreAvailable={isStoreAvailable}
                  orgStatusCode={orgStatusCode}
                >
                  <Header websiteTheme={websiteTheme} />
                  <Sidebar websiteTheme={websiteTheme} />
                  {children}
                  <Footer
                    websiteTheme={websiteTheme}
                    hasSideMenu={hasSideMenu}
                  />
                  <FixedCartBottom websiteTheme={websiteTheme} />
                </Providers>
              </GTMWrapper>
            </ErrorBoundary>
          </FaroErrorBoundary>
        </>
      ) : (
        <>{orgStatusCode !== 200 ? null : <UnavailableStore />}</>
      )}
    </ThemeProvider>
    // </Provider>
  )
}
